import gql from 'graphql-tag';

import {
  virtualPabxAgentStatisticsFragment,
  virtualPabxQueueStatisticsFragment,
} from './fragments';

export const virtualPabxRealtimeToken = gql`
  query virtualPabxRealtimeToken {
    virtualPabxRealtimeToken {
      token
    }
  }
`;

export const removeAgentFromQueue = gql`
  mutation removeAgentFromQueue(
    $sipUsername: String!
    $queueId: Int
    $pabxId: Int!
  ) {
    removeAgentFromQueue(
      sipUsername: $sipUsername
      queueId: $queueId
      pabxId: $pabxId
    )
  }
`;

export const logoutAgentExtension = gql`
  mutation logoutAgentExtension($sipUsername: String!, $pabxId: Int!) {
    logoutAgentExtension(sipUsername: $sipUsername, pabxId: $pabxId)
  }
`;

export const pauseAgent = gql`
  mutation pauseAgent(
    $sipUsername: String!
    $pauseReason: String!
    $pabxId: Int!
  ) {
    pauseAgent(
      sipUsername: $sipUsername
      pauseReason: $pauseReason
      pabxId: $pabxId
    )
  }
`;

export const unpauseAgent = gql`
  mutation unpauseAgent($sipUsername: String!, $pabxId: Int!) {
    unpauseAgent(sipUsername: $sipUsername, pabxId: $pabxId)
  }
`;

export const spyAgent = gql`
  mutation spyAgent(
    $targetSipUsername: String!
    $originSipUsername: String!
    $mode: String!
  ) {
    spyAgent(
      targetSipUsername: $targetSipUsername
      originSipUsername: $originSipUsername
      mode: $mode
    )
  }
`;

export const virtualPabxQueueStatistics = gql`
  query virtualPabxQueueStatistics(
    $queueId: Int!
    $pabxId: Int!
    $startDate: String!
    $endDate: String!
    $timeZone: String!
  ) {
    virtualPabxQueueStatistics(
      queueId: $queueId
      pabxId: $pabxId
      startDate: $startDate
      endDate: $endDate
      timeZone: $timeZone
    ) {
      ...virtualPabxQueueStatisticsParts
    }
  }
  ${virtualPabxQueueStatisticsFragment}
`;

export const virtualPabxAgentStatistics = gql`
  query virtualPabxAgentStatistics(
    $personContextId: Int!
    $pabxId: Int!
    $startDate: String!
    $endDate: String!
    $timeZone: String!
  ) {
    virtualPabxAgentStatistics(
      personContextId: $personContextId
      pabxId: $pabxId
      startDate: $startDate
      endDate: $endDate
      timeZone: $timeZone
    ) {
      ...virtualPabxAgentStatisticsParts
    }
  }
  ${virtualPabxAgentStatisticsFragment}
`;
